import React from 'react';
import HeroSlider from '../components/HeroSlider';
import TopBanner from '../components/TopBanner';

import NavBar from '../components/Navbar';
import Products from './Products';
import About from './About';
import FAQ from './FAQ';
import Contact from './Contact';

const Home = () => (
  <>
    <TopBanner/>
    <NavBar textColor='#fff'/>
    <HeroSlider />
    <Products />
    <About />
    <FAQ />
    <Contact />
    {/* Next sections like Best Sellers, About, etc. */}
  </>
);

export default Home;
